// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Caml_array from "melange.js/caml_array.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function FileUploader(Props) {
  let onChangeOpt = Props.onChange;
  const onChange = onChangeOpt !== undefined ? onChangeOpt : (function (param) {
      
    });
  const match = React.useState(function () {
    
  });
  const setValue = match[1];
  const value = match[0];
  const inputRef = React.useRef(null);
  return JsxRuntime.jsx("div", {
    children: value !== undefined ? JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: value.name,
            className: ""
          }),
          JsxRuntime.jsx("button", {
            children: "удалить",
            className: "py-2 px-3 border border-gray-300 rounded-md text-sm leading-4 font-medium text-gray-700 hover:text-gray-500 focus:outline-hidden focus:border-blue-300 focus:ring-blue active:bg-gray-50 active:text-gray-800 transition duration-150 ease-in-out",
            type: "button",
            onClick: (function (param) {
              Curry._1(setValue, (function (param) {
                
              }));
              Curry._1(onChange, undefined);
            })
          })
        ],
        className: "flex flex-wrap max-w-full overflow-x-hidden space-x-2 items-center justify-between rounded-md h-24"
      }) : JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("svg", {
            children: JsxRuntime.jsx("path", {
              d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }),
            className: "mx-auto h-12 w-12 text-gray-400 stroke-1",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
          }),
          JsxRuntime.jsxs("p", {
            children: [
              JsxRuntime.jsx("input", {
                ref: inputRef,
                className: "hidden",
                type: "file",
                onChange: (function (ev) {
                  let file = Caml_array.get(ev.target.files, 0);
                  Curry._1(setValue, (function (param) {
                    return file;
                  }));
                  const reader = new FileReader();
                  reader.readAsDataURL(file);
                  reader.onload = (function (param) {
                    const content = String(reader.result).replace(/^data:(.*,)?/g, "");
                    Curry._1(onChange, content);
                  });
                })
              }),
              JsxRuntime.jsx("button", {
                children: "Upload a file",
                className: "font-medium text-primary hover:text-primary-lite focus:outline-hidden focus:underline transition duration-150 ease-in-out",
                type: "button",
                onClick: (function (param) {
                  const __x = inputRef.current;
                  Belt__Belt_Option.map((__x == null) ? undefined : Caml_option.some(__x), (function (el) {
                    return el.click();
                  }));
                })
              }),
              " or drag and drop"
            ],
            className: "mt-1 text-sm text-gray-600"
          }),
          JsxRuntime.jsx("p", {
            children: "p12 up to 10MB",
            className: "mt-1 text-xs text-gray-500"
          })
        ],
        className: "text-center h-24"
      }),
    className: "mt-2 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md"
  });
}

const make = FileUploader;

export {
  make,
}
/* react Not a pure module */
